const ExperienceList = [
  {
    id: 1,
    company: "Hisab OK",
    logo: "/assets/companyLogos/hisabok.jpg",
    position: "Software Engineer Intern",
    duration: "Feb 2026 - Apr 2026",
    period: "2 months",
    description: [
      "Designed and deployed cross-platform mobile features using React Native and Expo for Android and iOS within Agile development sprints, contributing to 3 production releases.",
      "Integrated RESTful APIs with Express.js and MongoDB and containerized development workflows using Docker, reducing deployment inconsistencies by 40%.",
      "Implemented Redux-based state management to centralize application state, reducing redundant API calls by 40% and improving overall application performance by 25%."
    ],
    certificateLink: "https://drive.google.com/file/d/1VfjpQUG_9HBK3_-2-_F9-8qQ5v38Ag0k/view?usp=sharing",
    certificateText: "Letter of Experience",
  },
  {
    id: 2,
    company: "UptoSkills",
    logo: "/assets/companyLogos/uptoskills.jpeg",
    position: "React JS Intern",
    duration: "Feb 2026 - May 2026",
    period: "3 months",
    description: [
      "Built responsive and accessible web interfaces using React.js and Tailwind CSS, improving frontend performance and user experience by 20% within a CI/CD pipeline using GitHub Actions.",
      "Implemented React Router with JWT-based authentication and authorization, reducing session-related errors by 35% and securing all protected application routes.",
    ],
    certificateLink: "https://drive.google.com/file/d/12_Hi8M-BQ9ifMMlY75edFGQWCOdv3JE9/view?usp=sharing",
    certificateText: "Letter of Experience",
  },
  {
    id: 3,
    company: "NULLCLASS",
    logo: "/assets/companyLogos/nullclass.png",
    position: "Web-developer Intern",
    duration: "Dec 2024 - Jan 2025",
    period: "1 month",
    description: [
      "Developed Full Stack website using M-E-R-N Stack Technologies.",
      "Designed, implemented, and optimized 3 distinct features for project, enhancing functionality and user experience ensuring efficient backend integration with robust frontend designs.",
      "Conducted testing and debugging to ensure high-quality code and seamless user interaction.",
      "Gained hands-on experience with RESTful APIs, database management, and deployment strategies.",
    ],
    certificateLink: "https://drive.google.com/file/d/1LILd1xF7hhjPFcCXddTqoTrV6ODFfVlR/view?usp=sharing",
    certificateText: "Letter of Recommendation",
  }
  
];

export default ExperienceList;
